<div>
    <h6 class="ap-green mt-1">{{header1}}</h6>
    <div>{{header2}}</div>
    <br/>
    <div>
        <dx-data-grid #sapVolumeBetterServedGrid style="width: 100%" [dataSource]="sapVolumeBetterServed"
        [remoteOperations]="{ groupPaging: false }" [wordWrapEnabled]="true" [showBorders]="true">
        <dxo-scrolling mode="virtual"></dxo-scrolling>
        <dxo-group-panel [visible]="true"></dxo-group-panel>
        <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                    text="Export to Excel">
                </dx-button>
            </dxi-item>
        </dxo-toolbar>

        <dxi-column dataField="proposedPlant" [groupIndex]="0" caption="Proposed Plant"></dxi-column>
        <dxi-column dataField="prodHierLevel3" [groupIndex]="1" caption="Prod"></dxi-column>
        <dxi-column dataField="plantSiteName" [groupIndex]="2" caption="Former Plant"></dxi-column>
        <dxi-column dataField="customer" caption="Customer"></dxi-column>
        <dxi-column dataField="oldMiles" caption="Old Miles"></dxi-column>
        <dxi-column dataField="newMiles" caption="New Miles"></dxi-column>
        <dxi-column dataField="mTperDay" caption="MT/Day"></dxi-column>
        <dxi-column dataField="saveddollar" format="currency" caption="Saved $/yr"></dxi-column>
        <dxi-column dataField="customerCount" caption="Customer Count"></dxi-column>
        <dxi-column dataField="tankCount" caption="Tank count"></dxi-column>
        <dxi-column dataField="sapCustomerID" caption="sapCustomerID"></dxi-column>
        <dxo-summary>
            <dxi-group-item [alignByColumn]="true" [customizeText]="getSumValueOnly" column="mTperDay"
                summaryType="sum"> </dxi-group-item>
            <dxi-group-item [alignByColumn]="true" [customizeText]="getDollerValueOnly" column="saveddollar"
                summaryType="sum"> </dxi-group-item>
            <dxi-group-item [alignByColumn]="true" [customizeText]="getCountValueOnly" column="customerCount"
                summaryType="sum"> </dxi-group-item>
            <dxi-group-item [alignByColumn]="true" [customizeText]="getCountValueOnly" column="tankCount"
                summaryType="sum"> </dxi-group-item>
        </dxo-summary>
    </dx-data-grid>
    </div>
</div>
